import ModalPanelController from "./modal_panel_controller"

export default class extends ModalPanelController {
  static targets = ["panel", "form", "nameInput", "urlInput", "errors", "dialog"]

  connect() {
    super.connect()
    if (this.openValue) this.focusNameInput()
  }

  close(event) {
    this.clearForm()
    super.close(event)
  }

  openValueChanged() {
    super.openValueChanged()
    if (this.openValue) this.focusNameInput()
  }

  clearForm() {
    if (this.hasFormTarget) this.formTarget.reset()

    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = ""
      this.#clearErrorBorder(this.nameInputTarget)
    }

    if (this.hasUrlInputTarget) {
      this.urlInputTarget.value = ""
      this.#clearErrorBorder(this.urlInputTarget)
    }

    this.errorsTargets.forEach((element) => element.remove())
  }

  focusNameInput() {
    requestAnimationFrame(() => {
      if (this.hasNameInputTarget) this.nameInputTarget.focus()
    })
  }

  #clearErrorBorder(el) {
    el.classList.remove("border-danger-border-strong")
    el.classList.add("border-input-border")
  }
}
